import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getAbstractOptions } from '@/module/Author/Abstract';
import { AbstractEdit } from '@/module/Author/Abstract/AbstractEdit';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { abstractId } = Route.useParams();
  const { data: abstract } = useSuspenseQuery(getAbstractOptions(abstractId));

  return <AbstractEdit abstract={abstract} />;
}
